<template>
  <div>
    <el-card style="margin-bottom:10px"
             shadow="nerver">
      <div class="filter-area">
        <!-- 目的地 -->
        <div>
          <select-dest placeholder="所属目的地"
                       @selectDest="selectDest"></select-dest>
        </div>
        <!-- 旅行方式 -->
        <div class="trip_attritube_style">
          <el-radio-group v-model="trip_mode"
                          size="mini">
            <el-radio-button label="1">探索模式</el-radio-button>
            <el-radio-button label="2">自驾/租车</el-radio-button>
            <el-radio-button label="3">拼团</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 搜索 -->
        <el-input size="mini"
                  style="width:20%;margin-left:20px"
                  placeholder="请输入迹点"
                  v-model="searchContentKeyword"
                  clearable>
          <el-button slot="append"
                     @click="searchButton"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <!-- 标签 -->
      <div class="filter-area-tag">
        <select-tag :showTitle="true"
                    :creatNewTag="false"
                    :tagList="contentTags"
                    @getSelectList="getSelectList"></select-tag>
      </div>
    </el-card>
    <!-- ---------------------------内容列表--------------------------- -->
    <el-card shadow="nerver"
             :style="bodyStyle"
             v-loading="loading">
      <!-- 新建 -->
      <div style="margin-bottom:10px">
        <el-button @click="creatNewTravelPlan"
                   size="mini"
                   type="primary">新建旅行方案</el-button>
      </div>
      <!-- 列表 -->
      <div>
        <el-table :data="TripPlanList"
                  :header-cell-style="courseRowClass"
                  style="width: 100%">
          <el-table-column prop="id"
                           label="方案ID"
                           align="center"
                           width="80">
          </el-table-column>
          <el-table-column prop="plan_name"
                           show-overflow-tooltip
                           label="行程名称"
                           align="left"
                           width="240">
          </el-table-column>
          <el-table-column prop="start_date"
                           width="100"
                           label="出发日期">
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           label="日行程包含">
            <template slot-scope="item">
              <el-popover placement="right"
                          @show="showDayTripRoute(item.row)"
                          @hide="emptyDayDetailList"
                          :title="`行程概况--行程码：`+ trip_code"
                          width="auto"
                          trigger="click">
                <!-- begin item.row.day_detail_list-->
                <div style="display:inline">
                  <div v-for="dayItem,index of day_detail_list"
                       :key="index">

                    第{{index+1}}天：
                    <div style="font-size:10px"
                         v-for="item,index of dayItem.overview"
                         :key="index">
                      <!-- 整日 -->
                      <div v-if="item.trip_type =='all_day'">
                        <span class="">整日</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                      <!-- 离开 -->
                      <div v-if="item.trip_type =='departure'">
                        <span class="">离开</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                      <!-- 中转 -->
                      <div v-if="item.trip_type =='transit'">
                        <span class="">中转</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                      <!-- 抵达 -->
                      <div v-if="item.trip_type =='arrival'">
                        <span class="">抵达</span> :
                        <span v-for="traver_item,index of item.list"
                              :key="index">-{{traver_item.name}} </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <show-qr-code :size="100"
                                  :showTitle="true"
                                  :code="trip_code"
                                  introduce="扫码查看方案"
                                  type="tripPlanReview"></show-qr-code>
                  </div>
                </div>
                <!-- off -->
                <div slot="reference">共{{item.row.days}}天行程:
                  <span v-for="dest_name,index in item.row.dest_name"
                        :key="index">{{dest_name}} <span v-if="item.row.dest_name.length!=index+1">, </span></span>
                </div>
              </el-popover>

            </template>
          </el-table-column>
          <el-table-column width="120"
                           align="center"
                           label="操作">
            <template slot-scope="item">
              <el-button-group>
                <el-button type="primary"
                           size="mini"
                           icon="el-icon-edit"
                           @click="editorTravelPlan(item.row)"
                           circle></el-button>
                <!-- 查看需求 -->
                <el-button type="success"
                           size="mini"
                           icon="el-icon-view"
                           @click="checkRequirement(item.row.require_id)"
                           circle></el-button>
              </el-button-group>
              <!-- 删除 -->
              <el-popover placement="top"
                          @hide="hideInputPassword"
                          v-model="item.row.visible"
                          width="160">
                <p>删除方案需要验证：</p>
                <div style="text-align: right; margin: 0">
                  <el-input style="margin:5px 0"
                            autocomplete="off"
                            v-model="showPasswordDelete"
                            size="mini"></el-input>
                  <el-button size="mini"
                             type="text"
                             @click="item.row.visible = false">取消</el-button>
                  <el-button type="primary"
                             size="mini"
                             @click="deleteTravelPlan(item.row)">删除</el-button>
                </div>
                <el-button type="primary"
                           slot="reference"
                           circle
                           icon="el-icon-delete"
                           size="mini"></el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- ----------------- 分页 ------------------ -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>

    </el-card>
    <!-- ---------------------------内容列表【结束】--------------------------- -->

    <!-- 对话框 需求单 -->
    <el-dialog title="需求单"
               @close="requireDetialVisibleClose()"
               :visible.sync="requireDetialVisible">
      <div>
        <div>行前资料：</div>
        <div class="mb10">
          <span class="ftw900">目的地：</span>
          <span v-for="dest,index in require_form.dest_name"
                :key="index">
            <span>{{dest}}</span>
            <!-- <span v-if="require_form.dest_name.length !== index+1">,</span> -->
          </span>
        </div>
        <span class="ftw900"> </span>
        <div>
          <div v-if="require_form.trip_date_type==1">
            <div>确定了出发日期，还没定机票/车票:
              <p> 出发：{{require_form.start_date}}</p>
              <p> 返回：{{require_form.end_date}}</p>
            </div>
          </div>
          <div v-else-if="require_form.trip_date_type==2">
            <div>
              <div> 已经订好机票/车票:</div>
              <el-image style="width: 100px; height: 100px"
                        :src=" trafficBcooking[0]"
                        :preview-src-list=" trafficBcooking">
              </el-image>
            </div>
          </div>
          <div v-else-if="require_form.trip_date_type==3">
            还未确定具体出发日期,<span> 大概日期：{{require_form.about_date}}</span>
          </div>
          <div v-else>未选择</div>
        </div>

      </div>
      <el-divider></el-divider>
      <div>
        <div class="mb10">
          <span class="ftw900">用户ID：</span>
          {{require_form.user_id}}
        </div>
        <div class="mb10">
          <span class="ftw900">联系人：</span>
          {{require_form.contact}}
        </div>
        <div class="mb10">
          <span class="ftw900">联系电话：</span>
          {{require_form.mobile}}
        </div>
        <div class="mb10">
          <span class="ftw900">微信：</span>
          {{require_form.wechat}}
        </div>
        <div class="mb10">
          <span class="ftw900"> 人群：</span>
          <div v-if="require_form.trip_people_type==0">
            与他/她来一场二人之旅
          </div>
          <div v-else-if="require_form.trip_people_type==1">带家人来场旅行（有老人或儿童必选）</div>
          <div v-else-if="require_form.trip_people_type==2">和朋友一起出来玩</div>
          <div v-else-if="require_form.trip_people_type==3">团队一行人出来嗨皮</div>
          <div v-else-if="require_form.trip_people_type==4">独自来一场旅行</div>
          <!--  -->
          <div class="mt10">
            <p> <span class="ftw900">总人数：</span> {{require_form.num_all}}</p>
            <p v-if="require_form.child_num!=0"><span class="ftw900">其中儿童：</span>{{require_form.child_num}}{{require_form.child_info}}</p>
            <p v-if="require_form.elder_num!=0"><span class="ftw900">其中老人：</span>{{require_form.elder_num}}{{require_form.elder_info}}</p>

          </div>
        </div>
        <el-divider></el-divider>
        <div class="mb20">
          <div class="ftw900 mb10">要求：</div>
          <div class="backColorLightYellow pd10"> {{require_form.requirement_text}}</div>
        </div>
        <div style="display:flex">
          <div class="ftw900"> 旅行要求素材：</div>

          <el-image style="width: 100px; height: 100px"
                    :src="requireImageList[0]"
                    :preview-src-list="requireImageList">
          </el-image>
        </div>

        <div class="mt10">
          <span class="ftw900"> 可接受的旅行模式：</span>

          <div v-if="require_form.travel_mode_explore">可以探索旅行</div>
          <div v-if="require_form.travel_mode_driving">可以包车/自驾</div>
          <div v-if="require_form.travel_mode_tour">可以参加拼团</div>
        </div>
        <el-divider></el-divider>

      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="mini"
                   @click="outerVisible = false">关 闭</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectDest from '../../components/common/select/SelectDest'
import SelectTag from '../../components/common/select/SelectTag'
import showQRcode from '../../components/common/other/hoverShowQRcode.vue'

let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 150
export default {
  name: 'traver_plan_list',
  components: {
    'select-dest': SelectDest,
    'select-tag': SelectTag,
    'show-qr-code': showQRcode,
  },
  data() {
    return {
      loading: false,
      TripPlanList: [],
      bodyStyle: `min-height: ${contentHeight}px`,
      searchContentKeyword: '',
      requireDetialVisible: false,
      dest: '',
      trip_mode: '',
      contentTags: [], // 标签内容
      tag_list: [], // 选择的标签
      // 日行程列表
      day_detail_list: [],
      trip_code: '',
      dayTripData: [],
      // 需求单
      require_form: {},
      requireImageList: [],
      trafficBcooking: [],
      // 分页
      pagesize: 8,
      pagenum_system: 1,
      page_account: null,
      //
      showPasswordDelete: '',
    }
  },
  computed: {},
  mounted() {
    this.getAllTripPlanList()
  },
  methods: {
    // 隐藏密码框--删除日行程
    hideInputPassword() {
      this.showPasswordDelete = ''
    },
    // 查看需求单
    checkRequirement(require_id) {
      this.requireDetialVisible = true
      this.$http
        .get(`/traver/get_require_information?require_id=${require_id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            this.require_form = res.data.data
            this.requireImageList = JSON.parse(res.data.data.require_image_list)
            this.trafficBcooking = JSON.parse(res.data.data.traffic_booking)
          }
        })
    },
    //需求单对话框关闭
    requireDetialVisibleClose() {},
    // 删除方案
    deleteTravelPlan(item) {
      let pass = '09876'
      if (this.passwordDelete == '') {
        this.$message({
          message: '请输入密码验证权限',
          type: 'error',
        })
      } else {
        if (this.showPasswordDelete == pass) {
          // 执行删除
          this.$http
            .get(`/traver/delete_trip_plan?trip_plan_id=${item.id}`)
            .then((res) => {
              if (res.data.errno == '0') {
                this.$message({
                  message: res.data.errmsg,
                  type: 'success',
                })
                this.getAllTripPlanList()
              } else {
                this.$message({
                  message: res.data.errmsg,
                  type: 'error',
                })
              }
            })
        } else {
          this.$message({
            message: '验证不通过',
            type: 'error',
          })
        }
      }
    },
    // 编辑方案
    editorTravelPlan(item) {
      const newpage = this.$router.resolve({
        name: 'modify_travel_plan',
        query: {
          trip_id: item.id,
          require_id: item.require_id,
        },
      })
      window.open(newpage.href, '_blank')
    },
    // 表头的样式
    courseRowClass() {
      return 'background-color:whitesmoke; '
    },
    // 选择目的地
    selectDest(value) {
      if (value !== null) {
        this.dest = value
      } else {
        this.dest = ''
      }
    },
    // 选择标签
    getSelectList(value) {
      let selectList = []
      value.forEach((i) => {
        selectList.push(i.tag_id)
      })
      this.tag_list = selectList
    },
    searchButton() {
      this.getDayTripList()
    },
    // 编辑内容
    clickButtonEditor(value) {},
    // 获取所有方案
    getAllTripPlanList() {
      this.loading = true
      this.$http
        .get(
          `/traver/get_trip_plan_list?page_size=${this.pagesize}&page_number=${this.pagenum_system}`
        )
        .then((res) => {
          const { errno, errmsg, data } = res.data
          this.page_account = res.data.page_account

          if (errno == '0') {
            this.TripPlanList = data
            console.log(this.TripPlanList)
            this.loading = false
          } else {
            this.$message({
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    handleCurrentChange_system(page) {
      this.TripPlanList = []
      this.pagenum_system = page
      this.getAllTripPlanList()
    },
    emptyDayDetailList() {
      this.day_detail_list = []
    },
    showDayTripRoute(item) {
      // console.log(item)
      this.$http
        .get(`/traver/get_day_plan_detail_of_overview?plan_id=${item.id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            console.log(res)
            this.day_detail_list = res.data.data
            this.trip_code = res.data.code
          }
        })
    },
    //   创建方案
    creatNewTravelPlan() {
      const newpage = this.$router.resolve({
        name: 'creat_travel_plan',
      })
      window.open(newpage.href, '_blank')
    },
  },
}
</script>

<style>
.filter-area {
  display: flex;
}
.trip_attritube_style {
  margin-left: 20px;
}
.filter-area-tag {
  margin-top: 20px;
}
.weekend-style-day-trip {
  font-size: 10px;
  color: lightgrey;
  /* background-color: #ff5421; */
  padding: 0 5px;
}
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>